import { render } from "./PronosticoCabecera.vue?vue&type=template&id=10207366"
import script from "./PronosticoCabecera.vue?vue&type=script&lang=js"
export * from "./PronosticoCabecera.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__